<template>
  <div>
    <Cover />
    <Letter />
    <PeninsularIntro />
    <PeninsularTables 
      :selectedItems="selectedItems" 
      @updateTotalPages="handleUpdateTotalPages" 
    />
    <InsularIntro v-show="isCannarySelected" />
    <InsularTables @updateTotalPages="handleUpdateTotalPages" />
    <AdditionalServices />
    <!-- <OtherConsiderations /> -->
    <!-- <Aduaneros v-show="isCannarySelected" /> -->
    <InternationalIntro v-show="isInternationalSelected" />
    <InternationalTables
      v-show="isInternationalSelected"
      @updateTotalPages="handleUpdateTotalPages"
    />
    <AdditionalServicesInternational v-show="isInternationalSelected" />
    <ServicesAgreement @updateTotalPages="handleUpdateTotalPages" />
    <ContractText />
    <!-- <Sepa v-if="isPaymentDebit" /> -->
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import { GET_OFFER_ITEM } from '@/store/modules/offer/getters'
import { DEBIT_PAYMENT_METHODS } from '@/helpers/constants'
import { getSectionPreviousPages } from '@/containers/offer-form/sign-off/getSectionPreviousPages'
import Cover from '@/containers/offer-form/sign-off/pdf-venta-directa-2025-pt/Cover'
import Letter from '@/containers/offer-form/sign-off/pdf-venta-directa-2025-pt/Letter'
import PeninsularIntro from '@/containers/offer-form/sign-off/pdf-venta-directa-2025-pt/PeninsularIntro'
import PeninsularTables from '@/containers/offer-form/sign-off/pdf-venta-directa-2025-pt/PeninsularTables'
import InsularIntro from '@/containers/offer-form/sign-off/pdf-venta-directa-2025-pt/InsularIntro'
import InsularTables from '@/containers/offer-form/sign-off/pdf-venta-directa-2025-pt/InsularTables'
import AdditionalServices from '@/containers/offer-form/sign-off/pdf-venta-directa-2025-pt/AdditionalServices'
// import OtherConsiderations from '@/containers/offer-form/sign-off/pdf-venta-directa-2025-pt/OtherConsiderations'
// import Aduaneros from '@/containers/offer-form/sign-off/pdf-venta-directa-2025-pt/Aduaneros'
import InternationalIntro from '@/containers/offer-form/sign-off/pdf-venta-directa-2025-pt/InternationalIntro'
import InternationalTables from '@/containers/offer-form/sign-off/pdf-venta-directa-2025-pt/InternationalTables'
import AdditionalServicesInternational from '@/containers/offer-form/sign-off/pdf-venta-directa-2025-pt/AdditionalServicesInternational'
import ServicesAgreement from '@/containers/offer-form/sign-off/pdf-venta-directa-2025-pt/ServicesAgreement'
import ContractText from '@/containers/offer-form/sign-off/pdf-venta-directa-2025-pt/ContractText'
// import Sepa from '@/containers/offer-form/sign-off/pdf-venta-directa-2025-pt/Sepa'
import '@/styles/pdf-vd2024.scss'

const ISLANDS_PRODUCTS = [
  'TARIFF_STANDARD_PTM',
  'TARIFF_STANDARD_PTE',
  'TARIFF_STANDARD_PTE_ACORES',
  'TARIFF_STANDARD_PTE_MADEIRA',
  'TARIFF_STANDARD_BALMARITIMO',
  'TARIFF_STANDARD_BALEXPRESS',
  'TARIFF_STANDARD_PTI',
  'TARIFF_STANDARD_CANEXPRESS',
  'TARIFF_STANDARD_OTHERDESTINATIONS',
]

const INTERNATIONAL_PRODUCTS = ['JSON_INTEXP', 'JSON_INTSTD', 'JSON_INT_ECOMMERCE']

export default {
  name: 'PdfVentaDirecta2025Pt',
  components: {
    Cover,
    Letter,
    PeninsularIntro,
    PeninsularTables,
    InsularIntro,
    InsularTables,
    AdditionalServices,
    // OtherConsiderations,
    // Aduaneros,
    InternationalIntro,
    InternationalTables,
    AdditionalServicesInternational,
    ServicesAgreement,
    ContractText,
    // Sepa,
  },
  computed: {
    ...mapGetters('offer', [GET_OFFER_ITEM]),
    ...mapState('process', ['pdfPagesPerSection']),
    getProductList() {
      return this[GET_OFFER_ITEM]('productList')
    },
    additionalServices() {
      return this[GET_OFFER_ITEM]('extraServicesList')
    },
    paymentMethods() {
      return this[GET_OFFER_ITEM]('paymentMethods')
    },
    isPaymentDebit() {
      const selectedPaymentMethod = this.paymentMethods.find(method => method.isSelected)?.id
      return DEBIT_PAYMENT_METHODS.includes(selectedPaymentMethod)
    },
    sectionsPages() {
      return {
        Cover: 1,
        Letter: 1,
        PeninsularIntro: 1,
        PeninsularTables: 1,
        InsularIntro: 1,
        InsularTables: 1,
        AdditionalServices: 1,
        OtherConsiderations: 3,
        Aduaneros: 1,
        InternationalIntro: 1,
        InternationalTables: 1,
        AdditionalServicesInternational: 1,
        ServicesAgreement: 1,
        ContractText: 7,
        Sepa: this.isPaymentDebit ? 1 : 0,
      }
    },
    selectedItems() {
      // Devuelve la lista de todos los productos obligatorios + los que han sido seleccionados en el paso anterior.
      return this.getProductList?.filter(el => el.isSelected || el.isPreSelected || el.isMandatory)
    },
    islands() {
      return this.selectedItems?.filter(el => ISLANDS_PRODUCTS.includes(el.desc_key)) 
    },
    isCannarySelected() {
      return this.islands?.length !== 0
    },
    international() {
      return this.selectedItems?.filter(el => INTERNATIONAL_PRODUCTS.includes(el.desc_key))
    },
    isInternationalSelected() {
      return this.international?.length !== 0
    },
  },
  methods: {
    ...mapMutations('process', ['setPdfSectionPages']),
    handleUpdateTotalPages(sectionPages) {
      this.setPdfSectionPages(sectionPages)
    },
    formatNumber(num, decimals = 2) {
      return parseFloat(num)
        .toFixed(decimals)
        .replace('.', ',')
        .replace(/,0+$/, '')
    },
    additionalServiceData(service) {
      return {
        value: this.formatNumber(service.value),
        minValue: this.formatNumber(service.minValue),
      }
    },
    getAdditionalServiceByField(field, value) {
      if (!this.additionalServices) return {}
      const service = this.additionalServices.find(element => element[field] === value)
      return service ? this.additionalServiceData(service) : {}
    },
    getAdditionalServiceById(id) {
      return this.getAdditionalServiceByField('id', id)
    },
    getAdditionalServiceByDesc(desc) {
      return this.getAdditionalServiceByField('desc_key', desc)
    },
    sectionPreviousPages(section) {
      const sections = [
        'Cover',
        'Letter',
        'PeninsularIntro',
        'PeninsularTables',
        'InsularIntro',
        'InsularTables',
        'AdditionalServices',
        'OtherConsiderations',
        'Aduaneros',
        'InternationalIntro',
        'InternationalTables',
        'AdditionalServicesInternational',
        'ServicesAgreement',
        'ContractText',
        'Sepa',
      ]
      const previousSections = sections.slice(0, sections.indexOf(section))
      return getSectionPreviousPages(this.pdfPagesPerSection, previousSections)
    },
  },
  created() {
    this.setPdfSectionPages(this.sectionsPages)
  },
}
</script>
